<app-tiles></app-tiles>
<!--<app-info-cards></app-info-cards>-->
<app-analytics></app-analytics>
<div fxLayout="row wrap">
    <div fxFlex="100" [fxFlex.gt-sm]="100" class="p-2" *ngIf="rentings.length >0"> 
        <app-latest-orders [type]="'renting'" [rentings]="rentings"></app-latest-orders>
    </div>
    
</div>

<div fxLayout="row wrap">
    <div fxFlex="100" [fxFlex.gt-sm]="100" class="p-2" *ngIf="users.length >0"> 
        <app-latest-orders [type]="'user'" [users]="users"></app-latest-orders>
    </div>
</div>

<div fxLayout="row wrap">
    <div fxFlex="100" fxFlex.gt-sm="100" class="p-2" *ngIf="cars.length >0"> 
        <app-latest-orders [type]="'car'" [cars]="cars"></app-latest-orders>
    </div>
</div>